<!-- #region Add Update modal -->
<p-sidebar [(visible)]="showaddUpdateModal" [position]="'right'" (onHide)="closePaymentDialogue()" [dismissible]="false"
    [style]="{width:'60rem'}">
    <ng-template pTemplate="header">
        <h3>{{ context }} Vault Payments</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <app-vault-pay-addupdate [vaultPayData]="vaultSupportData"
            (changeModalStatus)="changeAddUpdateModelState($event)" [context]="context"></app-vault-pay-addupdate>
    </ng-template>
</p-sidebar>
<!-- #endregion  -->

<!-- #region Booking List -->
<app-vault-pay-list [vaultPayListData]="vaultPayList"
    (changeModelStatus)="changeAddUpdateModelState($event)"></app-vault-pay-list>
<!-- #endregion -->